import { Instagram, Link2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { formatRupiah } from "@/lib/api";

export const productLink = (id) => `${window.location.origin}/#produk-${id}`;

const BTN =
  "p-2 rounded-lg border border-[#D5CCBC] text-[#3D5A40] hover:bg-[#EAF2E9] hover:border-[#3D5A40] transition-colors";

export default function ShareButtons({ product }) {
  const link = productLink(product.id);
  const caption = `${product.name} — ${formatRupiah(product.price)} di Puspita Florist 🌸\n${link}`;

  const shareWa = () =>
    window.open(`https://wa.me/?text=${encodeURIComponent(caption)}`, "_blank", "noopener");

  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    }
  };

  const copyLink = async (msg) => {
    const ok = await copyText(msg ? caption : link);
    if (ok) toast.success(msg || "Link produk disalin");
    else toast.error("Gagal menyalin link");
  };

  const shareIg = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: product.name, text: caption, url: link });
        return;
      } catch {
        /* user cancelled or unsupported, fall through */
      }
    }
    await copyLink("Caption & link disalin — tempel di Story/DM Instagram");
    window.open("https://www.instagram.com/", "_blank", "noopener");
  };

  return (
    <div className="flex items-center gap-1.5" data-testid={`share-${product.id}`}>
      <button type="button" onClick={shareWa} aria-label="Bagikan ke WhatsApp" title="Bagikan ke WhatsApp" data-testid={`share-wa-${product.id}`} className={BTN}>
        <MessageCircle className="w-3.5 h-3.5" />
      </button>
      <button type="button" onClick={shareIg} aria-label="Bagikan ke Instagram" title="Bagikan ke Instagram" data-testid={`share-ig-${product.id}`} className={BTN}>
        <Instagram className="w-3.5 h-3.5" />
      </button>
      <button type="button" onClick={() => copyLink()} aria-label="Salin link produk" title="Salin link produk" data-testid={`share-copy-${product.id}`} className={BTN}>
        <Link2 className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
